import React from "react";
const Schedule = () => <div>Schedule Demo</div>;
export default Schedule;
